import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { Button } from 'nxui/src'
import { Domain as DomainModel } from 'models/domain'
import { getActiveSections } from 'router/userRouter'
import { Domain } from 'containers/domains/domains.styles'
import { setSupportOpen } from 'store/slices/supportSlice'

/**********************************************************************************************************
 *   TYPE DEFINITIONS
 **********************************************************************************************************/
type DomainRedemptionNoticeType = React.FC<{
    domain: DomainModel
}>

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export const DomainRedemptionNotice: DomainRedemptionNoticeType = ({ domain }) => {
    /***** HOOKS *****/
    const dispatch = useAppDispatch()

    /***** SELECTORS *****/
    const isSupportRoutesActive = useAppSelector((state) => {
        const activeSections = getActiveSections(state.app.appSettings.section)
        return activeSections.includes('support')
    })

    /***** RENDER *****/
    return (
        <Domain.Pending>
            <main>
                <Domain.Icon status={domain.status}>
                    <ExclamationTriangleIcon width='28px' aria-hidden='true' />
                </Domain.Icon>
                <h2>Domain is in Redemption Period</h2>
                <p>This domain is currently in the redemption period, please contact support to restore this domain.</p>
                {isSupportRoutesActive && (
                    <Button type='button' color='primary' onClick={() => dispatch(setSupportOpen(true))}>
                        Contact Support
                    </Button>
                )}
            </main>
        </Domain.Pending>
    )
}
